import styled from "styled-components";

const CustomButton = styled.button`
  color: #ffffff;
  background-color: #009b86;
  padding: 8px 15px;
  font-size: 17px;
  border: none;
  border-radius: 4px;
  box-shadow: none;
  &:hover {
    background-color: #009b86;
    box-shadow: 0px 0px 2px #000000;
  }
  margin-top: 18px;
`;

export default CustomButton;
